import React from 'react';
import { Outlet } from 'react-router-dom';

import { DashboardLayout } from '@freelancelabs/components';

import Sidebar from './Sidebar';

/**
 * La coquille des écrans privés d'`account`, la même que celle du portail et du
 * back-office : `DashboardLayout` pose le rail à gauche et le contenu à droite.
 *
 * **Elle ne couvre PAS `RedirectMiddleware`**, et c'est ce qui la rend juste. Cette page
 * est un passage : elle fait accepter les CGU, elle dresse la barrière du MFA, puis elle
 * s'en va. Une barre latérale y proposerait « Mon profil » à quelqu'un qui n'a pas encore
 * franchi une condition d'entrée, et la barrière du MFA cesserait d'être une barrière : on
 * en sortirait par le rail.
 */
const PrivateLayout = () => (
    <DashboardLayout sidebar={<Sidebar />}>
        <Outlet />
    </DashboardLayout>
);

export default PrivateLayout;
